import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import Logger from 'data/common/Logger';
import mainRoutes from 'data/common/routes';
import { SecuredLayout, PublicLayout, AppLayout, ErrorLayout } from 'layouts';
import Error404 from 'scenes/Errors/error404';
import routes from '../../routes';

class App extends Component {
    routerComponent = (Component, props) => {
        const { store } = this.props;
        const accessToken = localStorage.getItem('access_token');
        const path = props.match.path;
        const route = routes.getIn([path], {});
        let isRouteNeedLogged = !!route.must_logged;
        let isRouteNeedNotLogged = !!route.must_not_logged;

        if (isRouteNeedNotLogged && accessToken && path !== '/') return <Redirect to="/" />;

        if (isRouteNeedLogged) {
            if (!accessToken && path !== '/login') return <Redirect to="/login" />;
        }

        const profile = store.getState().data.user;
        if (route.right && profile && !profile.get('admin') && !profile.getIn(['user_rights', route.environment], []).includes(route.right)) {
            Logger.debug('Redirect to 403 from react router');
            return <Redirect to="/error/403" />;
        }
        props.history.environment = route.environment;
        return <Component environment={route.environment} {...props} />;
    };

    render() {
        const { location } = this.props;

        const routerComponents = [];
        const routerEnvironments = {};
        let background = location.modal && location.modal.background;
        routes
            .sortBy(route => (route.index ? route.index : 100))
            .map(route => {
                if (route.environment === 'mainRoutes') {
                    return routerComponents.push(
                        <Route
                            key={route.path}
                            exact
                            path={route.path}
                            component={props => {
                                if (route.error) {
                                    return (
                                        <ErrorLayout environment={route.environment} route={route.path}>
                                            {this.routerComponent(route.component, props)}
                                        </ErrorLayout>
                                    );
                                } else if (route.must_logged) {
                                    return (
                                        <SecuredLayout environment={route.environment} route={route.path} mainRoutes={mainRoutes}>
                                            {this.routerComponent(route.component, props)}
                                        </SecuredLayout>
                                    );
                                } else {
                                    return <PublicLayout route={route.path}>{this.routerComponent(route.component, props)}</PublicLayout>;
                                }
                            }}
                        />
                    );
                }
                if (!routerEnvironments[route.environment]) routerEnvironments[route.environment] = [];
                routerEnvironments[route.environment].push(
                    <Route key={route.path} exact path={route.path} render={this.routerComponent.bind(this, route.component)} />
                );
            });
        // Gestion des routes par environments
        Object.keys(routerEnvironments).map(env => {
            routerComponents.push(
                <SecuredLayout key={env} path={`/${env}`} environment={env} mainRoutes={mainRoutes}>
                    <Fragment>
                        <Switch location={background || location}>
                            {routerEnvironments[env]}
                            <Route
                                path={`/${env}`}
                                exact
                                render={() => {
                                    let routePath = routes.filter(route => {
                                        return route.environment === env && route.firstPage;
                                    });
                                    return <Redirect to={routePath.keySeq().first()} />;
                                }}
                            />
                            <ErrorLayout environment={env} key={env}>
                                <Route component={Error404} />
                            </ErrorLayout>
                        </Switch>
                    </Fragment>
                </SecuredLayout>
            );
        });

        routerComponents.push(
            <ErrorLayout key="other">
                <Route component={Error404} />
            </ErrorLayout>
        );

        return (
            <AppLayout>
                <Switch>{routerComponents}</Switch>
            </AppLayout>
        );
    }
}

App.propTypes = {
    store: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired
};

export default withRouter(App);



// WEBPACK FOOTER //
// ./data/common/App.js